import { Box, LinearProgress } from '@mui/material';
// @mui
import { alpha, styled } from '@mui/material/styles';
import { m } from 'framer-motion';
import { useLocation } from 'react-router-dom';

// auth
import { useAuthContext } from '../../auth/useAuthContext';
// config
import { NAV } from '../../config-global';
// hooks
import useResponsive from '../../hooks/useResponsive';
//
import Logo from '../logo';
import ProgressBar from '../progress-bar';
import { useSettingsContext } from '../settings';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.background.default,
  bottom: 0,
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  position: 'fixed',
  right: 0,
  width: '100%',
  zIndex: 9998,
}));

const LoadingScreen = () => {
  const { pathname } = useLocation();

  const isDesktop = useResponsive('up', 'lg');

  const { isInitialized } = useAuthContext();

  const { themeLayout } = useSettingsContext();

  const isDashboard =
    isInitialized && pathname.includes('/dashboard') && isDesktop;

  const size =
    (themeLayout === 'mini' && NAV.W_DASHBOARD_MINI) ||
    (themeLayout === 'vertical' && NAV.W_DASHBOARD) ||
    128;

  return (
    <>
      <ProgressBar />

      <StyledRoot
        sx={{
          ...(isDashboard && {
            width: `calc(100% - ${size}px)`,
            ...(themeLayout === 'horizontal' && {
              height: `calc(100% - ${size}px)`,
              width: 1,
            }),
          }),
        }}
      >
        {isDashboard ? (
          <LinearProgress color="inherit" sx={{ maxWidth: 360, width: 1 }} />
        ) : (
          <>
            <m.div
              animate={{
                opacity: [1, 0.48, 0.48, 1, 1],
                scale: [1, 0.9, 0.9, 1, 1],
              }}
              transition={{
                duration: 2,
                ease: 'easeInOut',
                repeat: Infinity,
                repeatDelay: 1,
              }}
            >
              <Logo disabledLink sx={{ height: 64, width: 64 }} />
            </m.div>

            <Box
              animate={{
                borderRadius: ['25%', '25%', '50%', '50%', '25%'],
                opacity: [0.25, 1, 1, 1, 0.25],
                rotate: [270, 0, 0, 270, 270],
                scale: [1.6, 1, 1, 1.6, 1.6],
              }}
              component={m.div}
              sx={{
                border: (theme) =>
                  `solid 3px ${alpha(theme.palette.primary.dark, 0.24)}`,
                height: 100,
                position: 'absolute',
                width: 100,
              }}
              transition={{ duration: 3.2, ease: 'linear', repeat: Infinity }}
            />

            <Box
              animate={{
                borderRadius: ['25%', '25%', '50%', '50%', '25%'],
                opacity: [1, 0.25, 0.25, 0.25, 1],
                rotate: [0, 270, 270, 0, 0],
                scale: [1, 1.2, 1.2, 1, 1],
              }}
              component={m.div}
              sx={{
                border: (theme) =>
                  `solid 8px ${alpha(theme.palette.primary.dark, 0.24)}`,
                height: 120,
                position: 'absolute',
                width: 120,
              }}
              transition={{
                duration: 3.2,
                ease: 'linear',
                repeat: Infinity,
              }}
            />
          </>
        )}
      </StyledRoot>
    </>
  );
};

export default LoadingScreen;
